/**
 * Typed env access. Import `env` instead of reading import.meta.env directly.
 * Missing required vars are logged as warnings rather than throwing,
 * so preview/storybook keep working.
 */

type Env = {
  API_BASE: string;
  SENTRY_DSN: string | undefined;
  APP_VERSION: string;
  IS_DEV: boolean;
  IS_PROD: boolean;
};

function readString(key: string, fallback = ''): string {
  const v = (import.meta.env?.[key] as string | undefined) ?? '';
  return v || fallback;
}

export const env: Env = {
  API_BASE: readString('VITE_API_BASE', ''),
  SENTRY_DSN: readString('VITE_SENTRY_DSN') || undefined,
  APP_VERSION: readString('VITE_APP_VERSION', 'dev'),
  IS_DEV: import.meta.env?.DEV === true,
  IS_PROD: import.meta.env?.PROD === true,
};

// Fast fail in production without an explicit API_BASE
if (env.IS_PROD && !env.API_BASE) {
  // eslint-disable-next-line no-console
  console.warn(
    '[env] VITE_API_BASE is empty in production — API calls will be same-origin.'
  );
}
